module.exports = __webpack_public_path__ + "img/2e4b23950372bccdbeeafeb851b4d799.png";